import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'afoone-wxrl-rule-triggers',
  templateUrl: './wxrl-rule-triggers.component.html',
  styleUrls: ['./wxrl-rule-triggers.component.css']
})
export class WxrlRuleTriggersComponent {
  @Input()
  public triggersFormArray: FormArray;

  @Input()
  public canEdit: boolean = false;

  get triggers() {
    return this.triggersFormArray?.controls || [];
  }
}
